module.exports = __webpack_public_path__ + "img/icon_chat_share.97e411f9.png";